goog.provide('el8.appservice.realtime');

goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.dialog.viewInlineCda');
goog.require('el8.appchart.providers.main');
goog.require('el8.data.apptRooms');
goog.require('el8.data.apptTypes');
goog.require('el8.data.checklistTemplates');
goog.require('el8.data.labOrderSets');
goog.require('el8.data.practiceSettings');
goog.require('el8.practicedata.appts');
goog.require('el8.practicedata.incomingFileGroups');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.practicedata.recurringEventSchedules');
goog.require('el8.practicedata.uploadedFiles');
goog.require('el8.practicedata.uploadedImages');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.ptFamilyRelationships');
goog.require('el8.ptdata.ptProviders');
goog.require('el8.ptdata.smokingStatuses');
goog.require('el8.ptdata.rxHistoryDownloadSummaries');
goog.require('el8.ptdata.visitNotes');
goog.require('el8.ptdata.xmlSummaries');
goog.require('el8.service.intervals');


el8.appservice.realtime = (function() {

    /**
     * For now we only have ONE channel;
     */
    var _channelId = null;
    var _lastMsgProcessed = 0;
    var _lastMsgReceived = 0;

    var messagesQueue = [];
    var queueProcessorId = null;

    function refreshOrDeleteItem(entitySet, itemId, action) {
        if (_.contains(['UPDATED', 'UPDATE', 'CREATED', 'CREATE'], action)) {
            entitySet.refreshById(itemId);
        } else if (_.contains(['DELETED', 'DELETE'], action)) {
            entitySet.remove(itemId);
        } else {
            // e.g., the set was re-sorted
            entitySet.debouncedLoad(null, true);
        }
    }

    return {
        setChannelId: function(id) {
            _channelId = id;
        },
        getChannelId: function() {
            return _channelId;
        },
        setLastMsgReceived: function(id) {
            _lastMsgReceived = id;
        },
        getLastMsgReceived: function(id) {
            return _lastMsgReceived;
        },
        setLastMsgProcessed: function(id) {
            _lastMsgProcessed = id;
        },
        getLastMsgProcessed: function(id) {
            return _lastMsgProcessed;
        },
        queueMessages: function(messages) {
            if (messages.length === 0) { return; }

            messagesQueue = messagesQueue.concat(messages);
            this.setLastMsgReceived(messages[messages.length-1]['_msg_id']);
            if (!queueProcessorId) {
                var that = this;
                queueProcessorId = $.el8_setInterval(function() {
                    that.processMessageQueue();
                }, 500);
            }
        },
        processMessageQueue: function() {
            var MAX_MSGS_PER_INTERVAL = 5;
            var msgsToProcess = Math.min(messagesQueue.length, MAX_MSGS_PER_INTERVAL);

            for (var i=0; i < msgsToProcess; i++) {
                /* Shifting the array is O(N). This shouldn't be a problem for queues of order 10^3 but if we start significantly
                 * exceeding that we should use a smarter Queue (e.g., http://code.stephenmorley.org/javascript/queues/) */
                this.processMessage(messagesQueue.shift());
            }

            //this consumer should only run when there is work to do, so we aren't needlessly running every second
            if (messagesQueue.length === 0) {
                $.el8_clearInterval(queueProcessorId);
                queueProcessorId = null;
            }
        },
        processMessage: function(message) {
            if (message['_msg_id'] <= this.getLastMsgProcessed()) { return; }
            /**
             * Expect messages to take this form:
             *   'msg': {
             *       'document_type'    : entity.get_model_class(),
             *       'document_id'      : entity.id,
             *       'document_action'  : action,
             *       'user_id'          : ctx.user.id,
             *       'extra'       : { dictionary } [optional]
             *   }
             */
            var mClass = message['document_type'];
            var docId  = message['document_id'];
            var action = message['document_action'];
            var extra  = message['extra'];
            var userId = message['user_id'];
            // we have decided to not do batching for websocket messages,
            // so a single item will be nested under extra.data

            if(el8React.messenger) {
                el8React.messenger.send('WebsocketEvent', message);
            }

            switch (mClass) {
                case 'Appointment':
                        el8.practicedata.appts.realtimeNotify(docId, action);
                        break;
                case 'AppointmentRoom':
                        refreshOrDeleteItem(el8.data.apptRooms, docId, action);
                        break;
                case 'AppointmentType':
                        refreshOrDeleteItem(el8.data.apptTypes, docId, action);
                        break;
                case 'CareTeamPhysicianParticipation':
                case 'CareTeamPracticeParticipation':
                    if (el8Globals.FEATURES.PLR4Everyone) {
                        el8.ptdata.careTeamProviders.load();
                        el8.appchart.providers.main.refreshPatientTeam();
                    }
                    break;
                case 'ChecklistTemplate':
                        refreshOrDeleteItem(el8.data.checklistTemplates, docId, action);
                        break;
                case 'ClinicalFormCollection':
                        el8.ptdata.clinicalFormCollections.create(extra.data);
                        break;
                case 'DecisionSupports':
                        var currNote = el8.appchart.visitNote.main.getNote();
                        el8.data.decisionSupports.load();
                        if (currNote) {
                            el8.appchart.visitNote.refreshAlertFeed(currNote, false);
                        }
                        break;
                case 'DocumentReminderNotification':
                        el8.ptdata.documentReminderNotifications.refreshById(docId);
                        break;
                case 'IncomingFileGroup':
                        el8.practicedata.incomingFileGroups.realtimeNotify(docId, action, extra);
                        break;
                case 'LabOrder':
                        el8.ptdata.labOrders.refreshById(docId);
                        break;
                case 'LabOrderSet':
                        refreshOrDeleteItem(el8.data.labOrderSets, docId, action);
                        break;
                case 'Letter':
                        /* falls through */
                case 'LetterReceipt':
                    el8.ptdata.refreshDocById(docId);
                    break;
                case 'LetterRoutingRule':
                        if (el8.data.letterRoutes) {
                            el8.data.letterRoutes.debouncedLoad(null, true); // just reload
                        }
                        break;
                case 'LetterTemplate':
                        refreshOrDeleteItem(el8.practicedata.letterTemplates, docId, action);
                        break;
                case 'MedOrder':
                    if (extra && _.contains(['CREATED', 'CREATE'], action)) {
                        el8.ptdata.medOrders.create(extra.data.med_order);
                        el8.ptdata.medOrderThreads.create(extra.data.thread);
                    } else {
                        var medOrder = el8.ptdata.medOrders.refreshById(docId);
                        // we want to refresh the thread if the med order was canceled
                        // so that we can hide it if necessary
                        if (medOrder.isCanceled()) {
                            el8.ptdata.medOrderThreads.refreshById(medOrder.getThreadId());
                        }
                    }
                    break;
                case 'MessageThread':
                    if (action === 'UPDATED') {
                        el8.appchart.mainFeeds.outstanding.update();
                        el8.ptdata.refreshDocById(docId);
                        el8.appchart.mainFeeds.chart.update();
                    }
                    break;
                case 'Patient':
                        el8.appchart.cqmRefresh.forceRefresh(true);
                        el8.appchart.mainFeeds.chartFileUploader.refreshChangedSections(['demographics']);
                        break;
                case 'PatientAllergy':
                    el8.ptdata.ptAllergies.create(extra.data);
                    break;
                case 'PatientDrugIntolerance':
                        el8.ptdata.ptIntolerances.create(extra.data);
                        break;
                case 'PatientFamilyRelationship':
                    el8.ptdata.ptFamilyRelationships.create(extra.data);
                    break;
                case 'PatientHistoryItem':
                    el8.ptdata.historyItems.create(extra.data);
                    break;
                case 'PatientMaintenanceItem':
                    el8.ptdata.ptMaintItem.create(extra.data);
                case 'PatientProblem':
                    el8.ptdata.ptProblems.create(extra.data);
                case 'PatientProviderTeamMember':
                        el8.ptdata.ptProviders.debouncedLoad(null, true); // just reload
                        break;
                case 'PracticeReportType':
                        refreshOrDeleteItem(el8.data.reportTypes, docId, action);
                        break;
                case 'PracticeSettings':
                        el8.data.practiceSettings.load(true); // just reload
                        break;
                case 'PatientSmokingStatus':
                        el8.ptdata.currSmokingStatus = el8.ptdata.smokingStatuses.create(extra.data);
                        el8.ptdata.smokingStatuses.notify();
                        break;
                case 'PrenatalFlowsheet':
                case 'PrenatalFlowsheetVisitMeasurements':
                    el8.ptdata.prenatalFlowsheets.load(true); // just reload
                    break;
                case 'RecurringEventSchedule':
                        el8.practicedata.recurringEventSchedules.realtimeNotify(docId, action);
                        break;
                case 'RxHistoryDownloadSummary':
                        // action from server will be like 'CREATED' but EVENTS.CREATED = 'created'
                        var jsAction = EVENTS[action] || EVENTS.CREATED;
                        el8.ptdata.rxHistoryDownloadSummaries.trigger(jsAction, docId);
                        break;
                case 'ServiceLocation':
                        refreshOrDeleteItem(el8.data.serviceLocations, docId, action);
                        break;
                case 'StaffGroup':
                        refreshOrDeleteItem(el8.data.staffGroups, docId, action);
                        break;
                case 'UploadedImage':
                    el8.practicedata.uploadedImages.realtimeNotify(docId, action);
                    break;
                case 'UploadedFile':
                    el8.practicedata.uploadedFiles.realtimeNotify(docId, action);
                    break;
                case 'VisitNote':
                    el8.ptdata.visitNotes.realtimeNotify(docId, action);
                    break;
                case 'VisitNoteBullet':
                    switch (action) {
                      case 'DELETED':
                        el8.appchart.mgr.notes.removeBullet(docId);
                        break;

                      default:
                        var data = extra.data;
                        el8.appchart.mgr.notes.addText(data.text, data.category.toLowerCase());
                    }
                break;
                case 'VisitNoteType':
                    // we refresh the whole thing because edits here are soft-deletes
                    el8.data.visitNoteTypes.debouncedLoad(null, true);
                    break;
                case 'CarequalityXmlSummary':
                    if (action === 'XMLSUMMARY_CREATE_SUCCESS') {
                        var xmlSummary = message.extra.xml_summary
                        el8.ptdata.xmlSummaries.create(xmlSummary);
                        // only show CDA viewer if it's not already open and import was successful
                        if (message.extra.imported && !el8.appchart.dialog.viewInlineCda.isOpen()) {
                            el8.appchart.dialog.viewInlineCda.show({ summaryId: xmlSummary.id });
                        }
                    }
                    break;
                default:
                    break;
            }
            this.setLastMsgProcessed(message['_msg_id']);
        }
    };

})();
